<template>
  <div id="appH5R">
    <div class="inner-box" id="appH5RBody">
      <Header>
        <div class="head_r">
          <span @click="listShow">{{$t('contents')}}</span>
          <h2 class="over-hide">{{ course_title }}</h2>
        </div>
      </Header>

      <div class="list" v-show="showList">
        <div class="mid" v-if="data.res_desc">
          <!-- <h2>{{data.res_title}}</h2> -->
          <p :class="{ 'over-hide-mul': !isOpen }" class="xq">
            {{ data.res_desc }}
          </p>
          <span @click="isOpen = !isOpen" v-show="desc_height > 52"
            >{{ isOpen ? $t('collapse') : $t('Deatil') }}...</span
          >
          <div class="course-info" v-if="showPdfList">
            <img src="../../assets/img/h5/course.png" alt="">
            <span class="info">课程资料({{data.materials.length}})</span>
            <span class="through" @click="previewPdf(data.materials[0])">查看</span>
          </div>
        </div>
        <div class="bottom">
          <div
            :class="chapter_type == -1 ? 'start-video-active' : 'start-video'"
            @click="fixedAnimate('start')"
          >
            {{$t('Opening')}}
          </div>
          <div
            class="list"
            v-for="(item, index) in data.part_list"
            :key="index"
          >
            <div class="tit" @click="changeCollapse(item, !item.isOpen)">
              <span :class="{ rol: item.isOpen }"></span>{{ item.part_title }}
            </div>
            <ul v-show="!item.isOpen">
              <!-- <li :class="{'active':activeShow == el.chapter_id}" @click.stop='doChapter(el,i,index)' v-for="(el,i) in item.chapter_list" :key="i"> -->
              <li
                :class="{ active: cur_data.chapter_id == el.chapter_id }"
                @click.stop="doChapter(el, i, index)"
                v-for="(el, i) in item.chapter_list"
                :key="i"
              >
                <span
                  :class="{
                    video: el.chapter_type == 1,
                    test: el.chapter_type == 2,
                    tuwen: el.chapter_type == 4,
                  }"
                ></span>
                <p class="over-hide">{{ el.chapter_title }}</p>
                <i
                  :class="{
                    complete: el.is_finished == 1,
                    uncompletes: el.is_finished == 0,
                  }"
                ></i>
              </li>
            </ul>
          </div>
          <div
            :class="chapter_type == -2 ? 'start-video-active' : 'start-video'"
            @click="fixedAnimate('end')"
          >
            {{$t('EndVideo')}}
          </div>
        </div>
        <!-- <div class="finish-progress" v-show="progressState">
          <span>已完成</span>
          <div class="progress-warpper">
            <div :style="progressLength" class="progress-content"></div>
          </div>
          <span>{{progressNumber}}%</span>
        </div> -->
      </div>
      <!-- <keep-alive></keep-alive> -->
      <router-view v-show="!showList"></router-view>

      <!-- 左右切换箭头 -->
      <div class="test_arrow" v-show="!showList">
        <a
          class="left"
          @click="checkChapter('prev', cur_chap_index, cur_part_index)"
          v-if="
            cur_data.chapter_id != firstChapterId &&
            chapter_type != -1 &&
            chapter_type != -2
          "
        ></a>
        <a
          class="left"
          @click="jumpLastChapter"
          v-else-if="chapter_type == -2"
        ></a>
        <a
          class="left"
          @click="fixedAnimate('start')"
          v-else-if="
            cur_data.chapter_id == firstChapterId &&
            chapter_type != -1 &&
            chapter_type != -2
          "
        ></a>
        <a
          class="right"
          @click="checkChapter('next', cur_chap_index, cur_part_index)"
          v-if="
            cur_data.chapter_id != lastChapterId &&
            chapter_type != -1 &&
            chapter_type != -2
          "
        ></a>
        <a
          class="right"
          @click="jumpfirstChapter"
          v-else-if="chapter_type == -1"
        ></a>
        <a
          class="right"
          @click="fixedAnimate('end')"
          v-else-if="
            cur_data.chapter_id == lastChapterId &&
            chapter_type != -1 &&
            chapter_type != -2
          "
        ></a>
      </div>
    </div>
  </div>
</template>
<script>
import aliPlayer from 'components/aliPlayer'
import aliPlayerHeadTail from 'components/aliPlayerHeadTail'
import Header from 'components/H5/Header.vue'
import mixins from 'components/H5/mixins/compon.js'
import { mapState } from "vuex"

export default {
  mixins: [mixins],
  data () {
    return {
      isOpen: true, // 描述显隐
      activeShow: 0, // 列表选中状态
      //  chapter_type:0, //小节类型
      chapter_title: '', // 小节名称
      chapter_id: '', // 小节id
      part_title: '', // 章节名称
      cur_zj_index: 0, // 当前的章节
      cur_xj_index: 0, // 当前的小节
      source: '', // 视频地址
      showList: false, // 列表显隐
      quiz_name: '',
      lastChapterId: '', // 最后一章节
      firstChapterId: '', // 第一章节
      checkedChapterType: '', // 切换后章节类型
      course_title: '', // 课件名称
      desc_height: 0, // 描述高度
      scrollingTop: 0, // 上次滚动高度
      progressState: true, // 滚动条显示隐藏
      showPdfList: true
    }
  },

  computed: {
    ...mapState({
      // 片头播放时长
      videoHeadTime: state => state.videoHeadTime
    }),
    chapter_type () {
      return this.$store.state.cur_data.chapter_type
    },
    cur_data () {
      return this.$store.state.cur_data
    },
    next_data () {
      return this.$store.state.next_data
    },
    cur_chap_index () {
      return this.$store.state.currentChapterIndex
    },
    cur_part_index () {
      return this.$store.state.currentPartIndex
    },
    // 学习小节进度
    progressNumber () {
      return Math.round(this.$store.state.studyProgress * 100)
    },
    // 进度条宽度
    progressLength () {
      return {
        width: this.$store.state.studyProgress > 0 ? `${this.$store.state.studyProgress * 100}%` : '.02rem'
      }
    },
  },
  beforeMount () {
    if (window.orientation == 180 || window.orientation == 0) {
      this.$nextTick(() => {
        this.$router.replace({ path: '/h5Dindex', query: { ...this.$route.query } })
      })
    }
    this.lastChapterId = JSON.parse(JSON.stringify(this.data)).part_list[this.data.part_list.length - 1].chapter_list.pop().chapter_id
    this.firstChapterId = this.data.part_list[0].chapter_list[0].chapter_id
    this.course_title = this.data.res_title

    let lessonLocation = this.$store.state.lessonLocation
    let chapterStatusStr = lessonLocation.split('||')[0]
    let currentChapter = lessonLocation.split('||')[1]
    let chapterStatusArr = chapterStatusStr.split('|')
    let pIndex = currentChapter.split('-')[0]
    let cIndex = currentChapter.split('-')[1]
    // if(this.$route.query.chapter_id) {
    //   this.data.part_list.map((li, index) => {
    //     li.chapter_list.map((item, idx) => {
    //       if(this.$route.query.chapter_id == item.chapter_id) {
    //         this.$store.commit('cur_data',item);
    //         this.cur_zj_index = index;
    //         this.cur_xj_index = idx;
    //         this.activeShow = item.chapter_id;
    //         this.chapter_title = item.chapter_title
    //         this.chapter_id = item.chapter_id;
    //         this.jumpChapterType(this.chapter_type)
    //       }
    //     })
    //   })
    // } else
    if (pIndex == 0 && cIndex == 0 && chapterStatusArr.join('').indexOf('1') < 0) {
      // 开始进入片头片尾
      this.$nextTick(() => {
        this.fixedAnimate('start')
      })
      this.$store.commit('setInFixedVideo', 'auto')
      // 开始进入片头片尾
    } else {
      this.cur_zj_index = this.cur_part_index
      this.cur_xj_index = this.cur_chap_index
      this.activeShow = this.cur_data.chapter_id
      this.chapter_title = this.cur_data.chapter_title
      this.chapter_id = this.cur_data.chapter_id
      this.jumpChapterType(this.chapter_type)
    }
    // 进度条初始化
    this.setProgressLength()
  },
  created() {
    this.showPdfList = this.data.materials && this.data.materials.length > 0 && this.$global_config.course_info.default
  },
  mounted () {
    //  window.addEventListener('scroll', this.handleScroll(this.setProgressState), true);
  },
  methods: {
    previewPdf(item) {
      this.$router.push({ name: 'preview_d', query: { title: item.title, path: item.path, redirect: this.$route.name, show: 'views_r', query: {...this.$route.query} } })
    },
    doChapter (el, i, index) { // 小节点击操作
      if (this.cur_data.chapter_id == el.chapter_id) {
        return
      }
      this.$store.commit('videoTime', 0)
      this.$store.commit('videoHeadTime', 0)
      //  debugger
      this.activeShow = el.chapter_id
      this.chapter_id = el.chapter_id
      this.chapter_title = el.chapter_title
      this.showList = false
      this.$store.commit('showList', this.showList)

      this.cur_zj_index = index
      this.cur_xj_index = i
      let cur_data = this.data.part_list[this.cur_zj_index].chapter_list[this.cur_xj_index]
      this.$store.commit('cur_data', cur_data)
      // this.$store.commit('next_data', this.data.part_list[this.cur_zj_index].chapter_list[(this.cur_xj_index + 1)])

      if (this.cur_xj_index < this.data.part_list[this.cur_zj_index].chapter_list.length - 1) {
        this.$store.commit('next_data', this.data.part_list[this.cur_zj_index].chapter_list[this.cur_xj_index + 1])
      } else if (this.cur_zj_index < this.data.part_list.length - 1) {
        this.$store.commit('next_data', this.data.part_list[this.cur_zj_index + 1].chapter_list[0])
      } else {
        this.$store.commit('next_data', el)
      }
      
      this.$store.commit('currentPartIndex', this.cur_zj_index)
      this.$store.commit('currentChapterIndex', this.cur_xj_index)

      let chapterNumCurs; let chapterNum = 0
      data.part_list.forEach((_e, i) => {
        // debugger
        if (this.cur_zj_index > i) {
          // chapterNumCurs = parseInt(this.cur_xj_index) + parseInt(_e.chapter_list.length)
          chapterNum += parseInt(_e.chapter_list.length)
          // console.log('this.chapterNumCurs'+chapterNumCurs)
        }
        if (this.cur_zj_index == 0) {
          chapterNumCurs = parseInt(this.cur_xj_index)
        } else {
          chapterNumCurs = parseInt(this.cur_xj_index) + chapterNum
        }
      })
      this.$store.commit('chapterNumCur', chapterNumCurs)

      this.part_title = this.data.part_list[this.cur_zj_index].part_title

      this.jumpChapterType(this.chapter_type)
    },
    listShow () {
      this.showList = !this.showList
      this.activeShow = this.cur_data.chapter_id
      if (this.showList) {
        this.getLessonLocation()
        this.$nextTick(() => {
          this.desc_height = this.desc_height > 0 ? this.desc_height : $('.xq').height()
          this.isOpen = false
        })
      }
      this.$store.commit('showList', this.showList)
    },
    changeCollapse (item, bool) {
      this.$set(item, 'isOpen', bool)
      this.$forceUpdate()
    },
    // 根据类型跳转小节
    jumpChapterType (chapterType) {
      if (chapterType == 1) { // 视频类型
        // this.source = this.data.part_list[0].chapter_list[0].file_path[0];
        // this.$store.commit('video_url',this.source);
        this.$router.replace({ path: '/h5Rindex/video', query: { chapter_id: this.activeShow } })
      } else if (chapterType == 2) { // 小测验
        this.$router.replace({ path: '/h5Rindex/test', query: { chapter_id: this.activeShow } })
      } else if (chapterType == -1) {
        this.fixedAnimate('start')
      } else if (chapterType == -2) {
        this.fixedAnimate('end')
      } else {
        // 图文 4
        this.$router.replace({ path: '/h5Rindex/tuwen', query: { chapter_id: this.activeShow } })
      }
    },
    // 跳转到第一小节
    jumpfirstChapter () {
      let cur_data = this.data.part_list[0].chapter_list[0]
      this.$store.commit('cur_data', cur_data)
      if (this.data.part_list[0].chapter_list.lehgth > 1) {
        this.$store.commit('next_data', this.data.part_list[0].chapter_list[1])
      } else if (this.data.part_list.length > 1) {
        this.$store.commit('next_data', this.data.part_list[1].chapter_list[0])
      } else {
        this.$store.commit('next_data', this.data.part_list[0].chapter_list[0])
      }
      this.$store.commit('currentPartIndex', 0)
      this.$store.commit('currentChapterIndex', 0)
      let checkedChapterType = cur_data.chapter_type
      if (checkedChapterType == 1) {
        this.$router.replace('/h5Rindex/video')
      } else if (checkedChapterType == 4) {
        this.$router.replace('/h5Rindex/tuwen')
      } else {
        this.getChapterAnswer()// 取答案数据
        this.$router.replace({ path: '/h5Rindex/test', query: { chapter_id: cur_data.chapter_id } })
      }
    },
    // 跳转到最后小节
    jumpLastChapter () {
      let lastSection = this.data.part_list.length - 1
      let lastChapter = this.data.part_list[lastSection].chapter_list.length - 1
      let cur_data = this.data.part_list[lastSection].chapter_list[lastChapter]
      this.$store.commit('cur_data', cur_data)
      this.$store.commit('currentPartIndex', lastSection)
      this.$store.commit('currentChapterIndex', lastChapter)
      let checkedChapterType = cur_data.chapter_type
      if (checkedChapterType == 1) {
        this.$router.replace('/h5Rindex/video')
      } else if (checkedChapterType == 4) {
        this.$router.replace('/h5Rindex/tuwen')
      } else {
        this.getChapterAnswer()// 取答案数据
        this.$router.replace({ path: '/h5Rindex/test', query: { chapter_id: cur_data.chapter_id } })
      }
    },
    // 出品结束动画
    fixedAnimate (type) {
      this.showList = false
      // 开始结束动画链接
      if (type == 'start') {
        console.log(630, this.videoHeadTime, this.cur_data)
        if(!this.videoHeadTime) {
          this.$store.commit('cur_data', {
            chapter_type: -1,
            activeShow: -1,
            type: 'start'
          })
        }
        this.$store.commit('currentPartIndex', 0)
        this.$store.commit('currentChapterIndex', 0)
        this.$router.replace('/h5Rindex/headVideo')
      } else {
        this.$store.commit('cur_data', {
          chapter_type: -2,
          activeShow: -1,
          type: 'end'
        })
        this.$router.replace('/h5Rindex/footVideo')
      }
    },
    // 函数防抖
    handleScroll (func, wait = 100) {
      let timer = null
      return function () {
        var context = this
        var args = arguments
        if (!timer) {
          timer = setTimeout(function () {
            func.apply(context, args)
            timer = null
          }, wait)
        }
      }
    },
    // 修改学习进度显示状态
    setProgressState () {
      // 页面滚动距顶部距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop
      let scroll = scrollTop - this.scrollingTop
      this.scrollingTop = scrollTop
      let scrollBottom = document.getElementById('appH5RBody').offsetHeight - window.innerHeight - scrollTop
      if ((scroll < 0 || scrollTop == 0) && scrollBottom > 2) {
        this.progressState = true
      } else {
        this.progressState = false
      }
    }
  },
  components: {
    aliPlayer,
    Header,
    aliPlayerHeadTail
  },
  watch: {
    '$route' () {
      if (window.orientation == 180 || window.orientation == 0) {
        this.$router.replace({ path: '/h5Dindex', query: { ...this.$route.query } })
      }
    }
  },

  beforeDestroy () {
    this.$store.commit('showList', false)
    // window.removeEventListener("scroll",this.handleScroll(this.setProgressState));
  }
}
</script>

<style lang="less" scoped>
#appH5R {
  color: @fontColor;
  font-size: 0.26rem;
  // height:100vh;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  /deep/.n-fixed-top {
    max-height: .78rem;
    min-height: .6rem;
    height: 10vh;
  }
  .inner-box {
    height: 100%;
    min-height: 100%;
    overflow-y: auto;
    background: #fff;
    >.list{
      background: #f8f8f8;
    }
  }
  .head {
    width: 100%;
    height: 0.7rem;
    line-height: 0.7rem;
    background: #f7f7f7;
    padding-left: 1rem;
    span {
      display: inline-block;
      width: 1.26rem;
      height: 0.54rem;
      line-height: 0.54rem;
      // margin:.12rem 0;
      margin-top: -0.2rem;
      margin-right: 0.3rem;
      padding-right: 0.3rem;
      text-align: right;
      background: url("../../assets/img/h5/head-xj.png") no-repeat center /
        contain;
      position: relative;
      top: -0.04rem;
      i.list {
        width: 0.27rem;
        height: 0.13rem;
        line-height: 0.44rem;
        background: url("../../assets/img/h5/head-ml.png") no-repeat center /
          contain;
        position: absolute;
        top: 0.5rem;
        left: 50%;
        margin-left: -0.14rem;
      }
    }
    h2 {
      display: inline-block;
      font-size: 0.3rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 86%;
    }
  }
  .mid {
    width: 100%;
    min-height: 0.9rem;
    // border-bottom:.1rem solid #F8F8F8;
    padding: 0.5rem 0.4rem 0.2rem 1.2rem;
    box-sizing: border-box;
    background: #fff;
    p {
      line-height: 0.48rem;
      color: #666;
      transition: all 0.5s;
      word-break: break-word;
    }
    span {
      color: @basic-color;
    }
    .course-info{
      margin-top: .3rem;
      padding-top: .2rem;
      // margin-bottom: .1rem;
      border-top: 1px solid #eeeeee;
      background: #fff;
      img{
        width: .26rem;
        margin-top: -.1rem;
      }
      .info{
        color: #252631;
        font-size: .3rem;
        margin-left: .11rem;
      }
      .through{
        width: .9rem;
        height: .4rem;
        line-height: .45rem;
        text-align: center;
        background-color: #ffffff;
        border-radius: .05rem;
        border: solid 1px #005587;
        display: block;
        color: #005587;
        font-size: .22rem;
        float: right;
      }
    }
  }
  .bottom {
    background: #fff;
    margin-top: .1rem;
    padding: 0.35rem 1.2rem 1.4rem;
    .start-video {
      padding-bottom: 0.4rem;
      padding-left: 0.05rem;
      display: flex;
      align-items: center;
      font-size: 0.28rem;
      &::before {
        content: "";
        width: 0.1rem;
        height: 0.1rem;
        background: #aaa;
        border-radius: 50%;
        margin-right: 0.2rem;
      }
    }
    .start-video-active {
      .start-video;
      color: @basic-color;
      &::before {
        background: @basic-color;
      }
    }
    .tit {
      font-size: 0.3rem;
      font-weight: bold;
      margin-bottom: 0.4rem;
      span {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background: url("../../assets/img/h5/more.png") no-repeat center /
          contain;
        margin-right: 0.1rem;
        transition: all 0.5s;
        transform: rotate(90deg);
        &.rol {
          // transform:rotate(90deg);
          transform: rotate(0deg);
        }
      }
    }
    ul {
      li {
        padding-left: 0.34rem;
        padding-bottom: 0.4rem;
        span {
          display: inline-block;
          width: 0.25rem;
          height: 0.25rem;
          vertical-align: middle;
          margin-right: 0.1rem;
          &.test {
            background: url("../../assets/img/h5/tests.png") no-repeat center /
              contain;
          }
          &.video {
            background: url("../../assets/img/h5/video.png") no-repeat center /
              contain;
          }
          &.tuwen {
            background: url("../../assets/img/h5/tuwens.png") no-repeat center /
              contain;
          }
          &.doc {
            background: url("../../assets/img/h5/docs.png") no-repeat center /
              contain;
          }
        }
        p {
          display: inline-block;
          max-width: 9.6rem;
          vertical-align: middle;
        }
        i {
          float: right;
          display: inline-block;
          width: 0.3rem;
          height: 0.3rem;
          background: #fff;
          border: 1px solid rgba(193, 193, 193, 1);
          border-radius: 50%;
          vertical-align: middle;
          box-sizing: border-box;
          &.uncomplete {
            background: url("../../assets/img/h5/uncomplete.png") no-repeat
              center / contain;
            border: none;
          }
          &.complete {
            background: url("../../assets/img/h5/complete.png") no-repeat center /
              contain;
            border: none;
          }
        }
        &.active {
          span {
            &.test {
              background: url("../../assets/img/h5/testb@3x.png") no-repeat
                center / contain;
            }
            &.video {
              background: url("../../assets/img/h5/videob@3x.png") no-repeat
                center / contain;
            }
            &.tuwen {
              background: url("../../assets/img/h5/tuwenb@3x.png") no-repeat
                center / contain;
            }
            &.doc {
              background: url("../../assets/img/h5/docb@3x.png") no-repeat
                center / contain;
            }
          }
          p {
            color: @basic-color;
          }
        }
      }
    }
  }
  .test_arrow {
    width: 100%;
    a {
      width: 0.46rem;
      height: 0.8rem;
      position: fixed;
      top: 50%;
      margin-top: -0.23rem;
      opacity: 0.25;
      &.left {
        left: 0.5rem;
        background: url("../../assets/img/h5/prev_test.png") no-repeat left
          center;
      }
      &.right {
        // right: 0.16rem;
        // left: 93.5%;
        right: 0.5rem;
        background: url("../../assets/img/h5/next_test.png") no-repeat right
          center;
      }
    }
  }
}
.finish-progress {
  width: 86%;
  background: #eeeeee;
  padding: 0.2rem 0.5rem;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0.8rem;
  left: 7%;
  box-sizing: border-box;
  border-radius: 0.6rem;
  font-size: 0.24rem;
  .progress-warpper {
    flex: 1;
    margin: 0 0.3rem;
    height: 0.08rem;
    background: white;
    border-radius: 0.04rem;
    .progress-content {
      height: 100%;
      background: #005587;
      border-radius: 0.04rem;
      transition: all 0.5s;
    }
  }
}
</style>
